import { PublicNav } from "@/components/PublicNav";
import { Footer } from "@/components/Footer";

export function MarketingLayout({ children }) {
  return (
    <div className="min-h-screen bg-background">
      <PublicNav />
      <main>{children}</main>
      <Footer />
    </div>
  );
}
